"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/tab/tab-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_UCZW3OGHcjs.CompositeContextProvider],
  [_UCZW3OGHcjs.CompositeScopedContextProvider]
);
var useTabContext = ctx.useContext;
var useTabScopedContext = ctx.useScopedContext;
var useTabProviderContext = ctx.useProviderContext;
var TabContextProvider = ctx.ContextProvider;
var TabScopedContextProvider = ctx.ScopedContextProvider;







exports.useTabContext = useTabContext; exports.useTabScopedContext = useTabScopedContext; exports.useTabProviderContext = useTabProviderContext; exports.TabContextProvider = TabContextProvider; exports.TabScopedContextProvider = TabScopedContextProvider;
